<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div v-if="inputGroupBy == 'monthly'" class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-month-picker v-model="inputFrom" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
        
                                <div class="col-md-7">
                                    <base-input alternative="" label="To"><br>
                                        <a-month-picker v-model="inputTo" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy" @click.prevent="sortChange">>
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-2">
                                    <base-checkbox class="mb-3" v-model="isSeparateSite">
                                        Separate per site
                                    </base-checkbox>
                                </div>
                            </div>
        
        
                            <div class="row">
                                <div class="col-md-7">
                                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                        {{toggleLabel}}
                                    </button>
                                </div>
                            </div>
        
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')" type="xlsx" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { getReportDescription } from '../../utilities';
    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        components: {
            AdvanceFilter,VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'salesman_id',
                groupOptions: [
                    {key: 'salesman_id', value: 'Salesman'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputSortBy: 'id',
                sortOptions: [
                    {key: 'id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'total_amount', value: 'Total Amount'},
                    {key: 'qty', value: 'Total Quantity'}
                ],
                isSeparateSite: true,
                inputFrom: moment().startOf('month'),
                inputTo: moment().endOf('month'),
                monthFormat: 'MM/YYYY',
                salesman_commissions: [],

                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,

                inputLocation: [],
                locationOptions: [],
                
                currDate: moment().format("L_LT").split(":").join(";"),
                showSortInfo: 'asc',
                inputShowTop: 0,
                JsonData: [],
                isShowTotalAmountWithoutTax: false,
                reportDescription: ''
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.reportDescription = await getReportDescription(this.currentProfile)

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }
        },
        computed: {
            ...mapState(['currentProfile','endPoint', 'categoriesOptions']),
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){

            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            sortChange(e){
                if(e.target.value != 'total_amount' || e.target.value != 'qty'){
                    this.inputShowTop = 0
                }
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            generateReport: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'salesman_commissions_reports?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    var paperSize = 'tabloid'

                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: paperSize });
          
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];

                    headers = [
                        [
                            '#',
                            {content: 'Trans Id', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Business Date', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Invoice No', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Barcode', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Description', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Retail Price', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Discount', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Gross Sales', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Net Sales', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Commission', styles: {halign: 'center', valign: 'center'}},
                        ]
                    ]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let total_qty = 0
                        let total_net_sales = 0
                        let total_commissions = 0

                        let grand_qty = 0
                        let grand_net_sales = 0
                        let grand_commissions = 0

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        let grouper = 'start'
                        let type_header = 'start'

                        if(this.birSalesReports.length > 0){
                            let monthly_grouper_arr = []
                            let arr = 'start'

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let detail = []
                                detail = [
                                    i+1,
                                    reportLine.trans_id,
                                    reportLine.business_date,
                                    reportLine.invoice_no,
                                    reportLine.barcode,
                                    reportLine.description,
                                    Number(reportLine.quantity),
                                    this.convertToCurrency(Number(reportLine.retail_price)),
                                    this.convertToCurrency(Number(reportLine.total_discount)),
                                    this.convertToCurrency(Number(reportLine.gross_sales)),
                                    this.convertToCurrency(Number(reportLine.net_sales)),
                                    this.convertToCurrency(Number(reportLine.salesman_commission)),
                                ];
                                

                                reportData.push(Object.assign({}, detail))

                                total_qty += Number(reportLine.quantity)
                                total_net_sales += Number(reportLine.net_sales)
                                total_commissions += Number(reportLine.salesman_commission)

                                grand_qty += Number(reportLine.quantity)
                                grand_net_sales += Number(reportLine.net_sales)
                                grand_commissions += Number(reportLine.salesman_commission)

                                if(i == this.birSalesReports.length-1){
                                    if(this.inputGroupBy != ''){
                                        let sub_detail = []
                                        let spacer = grouper_name
                                        if(this.inputGroupBy == 'supplier_type_id'){
                                            spacer = reportLine.header_name
                                        }

                                        sub_detail = ["", "", "", "",
                                        {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                        this.convertToCurrency(total_qty), '', '', '',this.convertToCurrency(total_net_sales) ,"",this.convertToCurrency(total_commissions)]
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))
                                    }

                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    reportData.push(Object.assign({}, ['', '', '', '', 'Grand Total :', '',
                                    this.convertToCurrency(grand_qty), '', '', '',this.convertToCurrency(grand_net_sales), "" ,this.convertToCurrency(grand_commissions)
                                    ]));
                                        
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""
                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        if(this.inputGroupBy != ''){
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            let sub_detail = []

                                            let spacer = grouper_name
                                            if(this.inputGroupBy == 'supplier_type_id'){
                                                spacer = reportLine.header_name
                                            }

                                            sub_detail = ["", "", "", "",
                                                {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                                this.convertToCurrency(total_qty), '', '', '', this.convertToCurrency(total_net_sales),"",this.convertToCurrency(total_commissions)]

                                            reportData.push(Object.assign({}, sub_detail))

                                            total_qty = 0
                                            total_net_sales = 0
                                            total_commissions = 0
                                        }
                                    }
                                    
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        let design_x = 525
                        let design_y = 260
                        
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Salesman Commission Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(15, 35, "Site: " + siteSpecific[x].report_details[0].site_name, "left");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(15, 35, "Site/s: " + site_text, "left");
                        }
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let splitTitle = doc.splitTextToSize("Filtered by: " + status_header + filter_header, 180);
                        doc.text(15,30,splitTitle);

                        let colStyles = {}
                        
                        colStyles = {
                            0: {cellWidth: 10},
                            1: {cellWidth: 30},
                            2: {cellWidth: 40},
                            3: {cellWidth: 25},
                            4: {cellWidth: 40},
                            5: {cellWidth: 80},
                            6: {cellWidth: 20},
                            7: {cellWidth: 25},
                            8: {cellWidth: 30},
                            9: {cellWidth: 30},
                            10: {cellWidth: 30},
                            11: {cellWidth: 30},
                        }
                        
                        doc.autoTable({
                            startY: 45,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right',
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Salesman Commission Report" + group_text, design_x, design_y, i, pageCount)
                        }
                    }
                    // window.open(URL.createObjectURL(doc.output("blob")))
                    doc.save(`Salesman_Commission_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,

                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'salesman_commissions_reports?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ["#", "Trans Id", "Business Date", "Invoice No", "Barcode", "Description", "Quantity", "Retail Price","Total Discount","Gross Sales","Net Sales","Salesman Commission"];


                    let site_specific = [];

                    for(let x=0; x < siteSpecific.length; x++){
                        this.salesman_commissions = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.salesman_commissions.length > 0){
                            let total_qty = 0
                            let total_amount_without_tax = 0
                            let total_total_amount = 0

                            let grand_qty = 0
                            let grand_total_amount_without_tax = 0
                            let grand_total_amount = 0

                            let grouper = 'start'
                            for(let i=0; i < this.salesman_commissions.length; i++){
                                let reportLine = this.salesman_commissions[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let detail = []
                                detail = [
                                    i+1,
                                    reportLine.trans_id,
                                    reportLine.business_date,
                                    reportLine.invoice_no,
                                    reportLine.barcode,
                                    reportLine.description,
                                    Number(reportLine.quantity),
                                    this.convertToCurrency(Number(reportLine.retail_price)),
                                    this.convertToCurrency(Number(reportLine.total_discount)),
                                    this.convertToCurrency(Number(reportLine.gross_sales)),
                                    this.convertToCurrency(Number(reportLine.net_sales)),
                                    this.convertToCurrency(Number(reportLine.salesman_commission)),
                                ]
                                if(this.isShowTotalAmountWithoutTax){
                                    detail.push(this.convertToCurrency(Number(reportLine.total_amount_without_tax)))
                                }

                                total_qty += Number(reportLine.qty)
                                total_total_amount += Number(reportLine.total_amount)
                                
                                grand_qty += Number(reportLine.qty)
                                grand_total_amount += Number(reportLine.total_amount)
                                if(this.isShowTotalAmountWithoutTax){
                                    total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                    grand_total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                }

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.salesman_commissions.length-1){
                                    //Grand Total
                                    
                                    let grand_detail = ['','','','Grand Total :','','',
                                        this.convertToCurrency(grand_qty),
                                        this.convertToCurrency(grand_total_amount)
                                    ]
                                    if(this.isShowTotalAmountWithoutTax){
                                        grand_detail.push(grand_total_amount_without_tax)
                                    }
                                    reportData.push(Object.assign({}, grand_detail));

                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.salesman_commissions[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        sub_detail = ['','','','Sub Total :','','',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_total_amount)
                                        ]

                                        if(this.isShowTotalAmountWithoutTax){
                                            sub_detail.push(total_amount_without_tax)
                                        }

                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                        total_total_amount = 0
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        if(this.isSeparateSite == true){
                            reportData.unshift([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Salesman Commission Reports" + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning = false
            },
            clearJsonData(){
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>
